import { inject, observer } from "mobx-react";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { Form } from "semantic-ui-react";
import { ISelectListModel } from "../../../modules/share/SelectListModel";
import { ISelectListGroupModel } from "../../../modules/systemhelper/SelectListGroupModel";

interface IProjectTypeDropdownList extends WithTranslation {
  orgId: number;
  code?: string;
  label?: string;
  disabledAllOption?: boolean;
  setField: (text: string, value: string) => void;
  setDropdown?: (id:number,text: string, value: string) => void;
  fiveYearProjectTypeStore?: ISelectListGroupModel;
  filterList?: string[];
  source?: string | null; // Add source prop to determine the source of the page
}

export const allOptionLabel = "ทั้งหมด";
export const allOptionCode = "projectTypeAll";

@inject("fiveYearProjectTypeStore")
@observer
class ProjectTypeDropdownList extends React.Component<
  IProjectTypeDropdownList
> {
  public async componentDidMount() {
    const { orgId, fiveYearProjectTypeStore, disabledAllOption, setField, source } = this.props;
    try {
      // ดึงข้อมูลประเภทโครงการ
      await fiveYearProjectTypeStore!.getProjectTypeByOrg(orgId, source);
      console.log("fiveYearProjectTypeStore: ", fiveYearProjectTypeStore);
      if(disabledAllOption){
        // ตรวจสอบว่ามีข้อมูลใน list หรือไม่
        if (fiveYearProjectTypeStore!.list.length > 0) {
          const firstOption = fiveYearProjectTypeStore!.list[0].dropdownOption;

          // ตั้งค่า state และเรียก setField เพื่ออัปเดตค่าเริ่มต้น
          this.setState({ code: firstOption.value });
          setField(firstOption.text, firstOption.value);
        }
      }
    } catch (e) {
      console.log("Error fetching project type:", e);
    }
  }

  public render() {
    const { code, disabledAllOption, label, t } = this.props;

    return (
      <Form.Dropdown
        label={label}
        placeholder={t("ProjectTypeDropdownList.pleaseSelect")}
        fluid
        selection
        value={code || (!disabledAllOption ? allOptionCode : undefined)}
        options={this.renderOption() as any}
        onChange={(event: React.SyntheticEvent, data: any) => {
          this.onChange(data);
        }}
      />
    );
  }

  private renderOption = () => {
    const {
      fiveYearProjectTypeStore,
      disabledAllOption,
      filterList,
      t,
    } = this.props;
    const options = [];
    if (!disabledAllOption) {
      options.push({
        id: undefined,
        text: t("ProjectTypeDropdownList.all"),
        value: allOptionCode,
      });
    }

    fiveYearProjectTypeStore!.list.forEach(
      (selectList: ISelectListModel, index: number) => {
        if (
          (filterList &&
            filterList.includes(selectList.dropdownOption.value)) ||
          !filterList
        ) {
          options.push(selectList.dropdownOption);
        }
      },
    );

    return options;
  };
  private setDropdown(id: number, code:string , text:string){

  }
  private onChange = (data: any) => {
    const { setField,setDropdown } = this.props;
    const { value } = data;
    const { id,text } = data.options.find((o: any) => o.value === value);
    const code = data.value === allOptionCode ? allOptionCode : data.value;
    setField(text, code);
    try{
      setDropdown!(id,text,code);
    }catch{

    }
  };
}

export default withTranslation()(ProjectTypeDropdownList);
